// @ts-nocheck
import React from 'react';
import UINumber from 'components/UI/Number/Number';
import classnames from 'classnames';

type UICurrencyProps = {
  children: number;
  className: string;
};

function UICurrency({ children, className, ...restProps }: UICurrencyProps) {
  return (
    <UINumber {...restProps} className={classnames('currency', className)}>
      {children}
    </UINumber>
  );
}

UICurrency.defaultProps = {
  className: null,
  format: '$0,0',
  children: null,
};

export default UICurrency;
